const tabs = document.querySelectorAll(
  '.make-reservation .category-item[data-step]'
);
const contentBox = document.querySelector('.content-box');
const sectionRoute = document.getElementById('map-form');
const sectionRouteInner = document.querySelector('.map-form');
const sectionCars = document.querySelector('.cars');
const sectionConfirm = document.querySelector('.payment');
const nextToCarsBtn = document.querySelector('[data-next-to-cars]');
const nextToPaymentBtn = document.querySelector('[data-to-payment]');
const backToRouteBtn = document.querySelector('[data-back]');
const backToCarsBtn = document.querySelector('[data-back-to-cars-choice]');

if (
  tabs.length &&
  contentBox &&
  sectionRoute &&
  sectionCars &&
  sectionConfirm &&
  nextToCarsBtn &&
  nextToPaymentBtn
) {
  const steps = ['route', 'cars', 'confirm'];
  let pendingConfirmAfterPassengers = false;
  let tabInitiatedNextToCars = false;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => handleTabClick(tab.dataset.step));
  });

  window.addEventListener('passengersModal:confirmed', () => {
    syncActiveTabs();
    if (pendingConfirmAfterPassengers) {
      pendingConfirmAfterPassengers = false;
      setTimeout(() => triggerToPayment(), 0);
    }
  });

  [backToRouteBtn, backToCarsBtn].forEach(btn => {
    btn?.addEventListener('click', () => {
      pendingConfirmAfterPassengers = false;
      setTimeout(syncActiveTabs, 0);
    });
  });
  nextToCarsBtn.addEventListener('click', () => {
    if (tabInitiatedNextToCars) {
      tabInitiatedNextToCars = false;
      return;
    }
    pendingConfirmAfterPassengers = false;
  });
  nextToPaymentBtn.addEventListener('click', () => {
    pendingConfirmAfterPassengers = false;
    setTimeout(syncActiveTabs, 0);
  });

  function handleTabClick(targetStep) {
    if (!targetStep) return;
    const currentStep = getCurrentStep();
    if (targetStep === currentStep) return;

    const targetIndex = steps.indexOf(targetStep);
    const currentIndex = steps.indexOf(currentStep);
    if (targetIndex === -1 || currentIndex === -1) return;

    if (targetIndex < currentIndex) {
      pendingConfirmAfterPassengers = false;
      showStep(targetStep);
      return;
    }

    if (targetStep === 'cars') {
      pendingConfirmAfterPassengers = false;
      tabInitiatedNextToCars = true;
      triggerToCars();
      return;
    }

    if (targetStep === 'confirm') {
      if (currentStep === 'cars') {
        pendingConfirmAfterPassengers = false;
        triggerToPayment();
        return;
      }
      pendingConfirmAfterPassengers = true;
      tabInitiatedNextToCars = true;
      triggerToCars();
    }
  }

  function triggerToCars() {
    nextToCarsBtn.click();
  }

  function triggerToPayment() {
    nextToPaymentBtn.click();
  }

  function showStep(step) {
    const showContent = step === 'route' || step === 'cars';
    contentBox.style.display = showContent ? 'block' : 'none';

    sectionRoute.style.display = step === 'route' ? 'block' : 'none';
    if (sectionRouteInner) {
      sectionRouteInner.style.display = step === 'route' ? 'flex' : 'none';
    }
    sectionCars.style.display = step === 'cars' ? 'flex' : 'none';
    sectionConfirm.style.display = step === 'confirm' ? 'flex' : 'none';
    syncActiveTabs();

    const targetEl =
      step === 'route'
        ? sectionRoute
        : step === 'cars'
        ? sectionCars
        : sectionConfirm;

    targetEl?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  }

  function syncActiveTabs() {
    const currentStep = getCurrentStep();
    document
      .querySelectorAll('.make-reservation .category-list')
      .forEach(list => {
        list.querySelectorAll('.category-item').forEach(item => {
          item.classList.toggle('active', item.dataset.step === currentStep);
        });
      });
  }

  function getCurrentStep() {
    if (isVisible(sectionConfirm)) return 'confirm';
    if (isVisible(sectionCars)) return 'cars';
    return 'route';
  }

  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== 'none';
  }
}
